import React from 'react';
import Icon from './Icon';
import { classNames } from '../../Services/helpers';

const AlertBadge = ({icon, theme, size, color, className, onClick, inline = false}) => {
    const colours ={
        'brand': 'bg-brand fill-white',
        'primary': 'bg-blue-100 fill-brand',
        'danger': 'bg-red-100 fill-red-600',
        'warning': 'bg-orange-100 fill-orange-600',
        'info': 'bg-blue-100 fill-blue-600',
        'success': 'bg-green-100 fill-green-600',
        'secondary': 'bg-gray-100 fill-gray-700',
    };
    const icons ={
        'danger': 'CircleExclamation',
        'warning': 'TriangleExclamation',
        'info': 'CircleInfo',
        'success': 'Check',
    };

    const _colour = color ?? colours[theme] ?? colours['default']

    const sizes = {
        'small': ['h-6 w-6', '0.5x'],
        'medium': ['h-8 w-8', '1x'],
        'large': ['h-12 w-12', '2x'],
    }

    return <span className={classNames(
            className,
            _colour,
            sizes[size ?? 'large'][0],
            'mx-auto shrink-0 items-center justify-center rounded-full',
            inline ? 'inline-flex' : 'flex',
            // sm:mx-0 sm:h-10 sm:w-10
        )}
        onClick={() => onClick && onClick()}
        >
        <Icon icon={(typeof icon === 'string') ? icon : (icons[theme] ?? 'Question')} size={sizes[size ?? 'large'][1]} />
    </span>
}

export default AlertBadge;